import { useState, useEffect } from 'react';
import api from '../api';

/* ── useInstitutionalConfirmation ──
   Hook that fetches SPX-implied levels and returns
   confirmation status for CW/PW. No UI — just data.
   
   Usage in Dashboard:
     const institutional = useInstitutionalConfirmation(ticker);
     // institutional.call_wall === true means SPX confirms
     // institutional.put_wall === true means SPX confirms
*/

export default function useInstitutionalConfirmation(ticker) {
  const [confirmation, setConfirmation] = useState({
    loaded: false,
    call_wall: false,
    put_wall: false,
  });

  useEffect(() => {
    if (ticker !== 'SPY') {
      setConfirmation({ loaded: true, call_wall: false, put_wall: false });
      return;
    }

    let cancelled = false;

    const fetch = async () => {
      try {
        const res = await api.get('/api/gex/SPY/institutional');
        if (cancelled) return;

        if (res.data?.available && res.data?.confirmation) {
          const conf = res.data.confirmation;
          setConfirmation({
            loaded: true,
            call_wall: conf.call_wall?.status === 'confirmed',
            put_wall: conf.put_wall?.status === 'confirmed',
          });
        } else {
          setConfirmation({ loaded: true, call_wall: false, put_wall: false });
        }
      } catch {
        if (!cancelled) {
          setConfirmation({ loaded: true, call_wall: false, put_wall: false });
        }
      }
    };

    fetch();
    return () => { cancelled = true; };
  }, [ticker]);

  return confirmation;
}
